import React from "react"
import { goToHomePage, RegistrationComplete } from "../../../views/register/RegistrationComplete"

export function RegistrationCompleteStep(): JSX.Element {
  return <RegistrationComplete onBenefitHighlights={goToHomePage} />
}
